import { render, staticRenderFns } from "./UsersForm.vue?vue&type=template&id=1a85702c&scoped=true"
import script from "./UsersForm.vue?vue&type=script&lang=js"
export * from "./UsersForm.vue?vue&type=script&lang=js"
import style0 from "./UsersForm.vue?vue&type=style&index=0&id=1a85702c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85702c",
  null
  
)

export default component.exports